var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCBCB",
    d: "M1.88 4.862c.261-.26.683-.26.944 0l5.185 5.185 5.185-5.185a.667.667 0 1 1 .943.943L8.48 11.462a.667.667 0 0 1-.942 0L1.88 5.805a.667.667 0 0 1 0-.943"
  })));
};
export default SvgChevronDown;